<template>
  <div class="ws-test">
    <div class="item" v-for="item in listData" :key="item.symbol">
      <span class="symbol">{{ item.symbol }}</span>
      <span class="price">价格：</span>
      <button @click="add(item)">追加订阅</button>
      <button @click="remove(item)">取消订阅</button>
    </div>
    <button @click="stop()">全部停止</button>
  </div>
</template>
<script>
export default {
  data() {
    return {
      listData: []
    };
  },
  created() {
    this.quoteSymbol();
  },
  methods: {
    quoteSymbol() {
      this.$apis
        .quoteSymbolApi({
          symbol: "HSI240",
          contractType: 70,
          limit: 100
        })
        .then(res => {
          this.listData = res.data.infos;
        });
    },
    add(item) {
      const msg = { MsgType: "SubTicks", MsgBody: { symbol: item.symbol } };
      this.$socket.sendMsg(msg);
    },
    remove(item) {
      const msg = { MsgType: "UnsubTicks", MsgBody: { symbol: item.symbol } };
      this.$socket.sendMsg(msg);
    },
    stop() {
      this.$socket.stop();
    }
  }
};
</script>

<style scoped lang="less">
.ws-test {
  .item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 80px;
  }
}
</style>
